import { call } from '../@';

const endSession = async (sessionId: string) => await call('sessions-end', { sessionId }, { keepalive: true });

export default endSession;
